import React, { useState } from "react";
import DevicesTable from "./DevicesTable";
import DevicesTableHeader from "./DevicesTableHeader";
import { TableContext } from "../index";
import { debug } from "../utils";
import { useHistory } from "react-router-dom";
import PaginationManager from "../view/PaginationManager";
import * as deviceSevice from "./deviceService";

function DevicesTableSection() {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        isLoading: true
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_table-card-v2">
                            <DevicesTableHeader />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12 pl-0">
                                            <DevicesTable />
                                            <PaginationManager getPage={deviceSevice.listPageable} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default DevicesTableSection;
